export { default } from '../../sub/hosting';

